// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile {
  width: 100%;
}

.profile__header {
  margin-bottom: 1.25rem;
}

.profile__header h1 {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 700;
}

.profile__header p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  line-height: 1.45;
}

.profile__card {
  width: 100%;
  padding: 1.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.profile__layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  align-items: start;
}

.profile__details-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.profile__details-box {
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
}

.profile__details-box h2 {
  margin: 0 0 1rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.profile__details-list {
  margin: 0;
}

.profile__details-item + .profile__details-item {
  margin-top: 0.85rem;
}

.profile__details-item {
  margin: 0;
}

.profile__details-item dt {
  margin: 0 0 0.35rem;
  color: var(--color-text-muted);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.profile__details-item dd {
  margin: 0;
  color: var(--color-text);
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
}

.profile__fields {
  min-width: 0;
}

.profile__security-heading {
  margin: 0 0 1rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.profile__field.data-page__modal-field {
  margin-bottom: 0.85rem;
}

.profile__field-control {
  position: relative;
}

.profile__field-control input {
  width: 100%;
  padding-left: 2.65rem;
  padding-right: 2.75rem;
}

.profile__field-control--no-icon input {
  padding-left: 0.85rem;
}

.profile__field-icon {
  position: absolute;
  top: 50%;
  left: 0.9rem;
  transform: translateY(-50%);
  display: inline-flex;
  width: 18px;
  height: 18px;
  color: var(--color-text);
  pointer-events: none;
}

.profile__field-icon svg,
.profile__field-icon .app-icon {
  width: 18px;
  height: 18px;
  color: var(--color-text);
}

.profile__toggle-password {
  position: absolute;
  top: 50%;
  right: 0.65rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.profile__toggle-password:hover {
  color: var(--color-text);
  background: var(--color-accent-soft);
}

.profile__toggle-password svg,
.profile__toggle-password .app-icon {
  width: 18px;
  height: 18px;
  color: var(--color-text);
}

.profile__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.85rem 1.1rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.profile__submit:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.profile__submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .profile__layout {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".profile {\n  width: 100%;\n}\n\n.profile__header {\n  margin-bottom: 1.25rem;\n}\n\n.profile__header h1 {\n  margin: 0 0 0.35rem;\n  font-size: 1.35rem;\n  font-weight: 700;\n}\n\n.profile__header p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.profile__card {\n  width: 100%;\n  padding: 1.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.profile__layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n.profile__details-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.profile__details-box {\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n}\n\n.profile__details-box h2 {\n  margin: 0 0 1rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n.profile__details-list {\n  margin: 0;\n}\n\n.profile__details-item + .profile__details-item {\n  margin-top: 0.85rem;\n}\n\n.profile__details-item {\n  margin: 0;\n}\n\n.profile__details-item dt {\n  margin: 0 0 0.35rem;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.profile__details-item dd {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.profile__fields {\n  min-width: 0;\n}\n\n.profile__security-heading {\n  margin: 0 0 1rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n.profile__field.data-page__modal-field {\n  margin-bottom: 0.85rem;\n}\n\n.profile__field-control {\n  position: relative;\n}\n\n.profile__field-control input {\n  width: 100%;\n  padding-left: 2.65rem;\n  padding-right: 2.75rem;\n}\n\n.profile__field-control--no-icon input {\n  padding-left: 0.85rem;\n}\n\n.profile__field-icon {\n  position: absolute;\n  top: 50%;\n  left: 0.9rem;\n  transform: translateY(-50%);\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  color: var(--color-text);\n  pointer-events: none;\n}\n\n.profile__field-icon svg,\n.profile__field-icon .app-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--color-text);\n}\n\n.profile__toggle-password {\n  position: absolute;\n  top: 50%;\n  right: 0.65rem;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.profile__toggle-password:hover {\n  color: var(--color-text);\n  background: var(--color-accent-soft);\n}\n\n.profile__toggle-password svg,\n.profile__toggle-password .app-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--color-text);\n}\n\n.profile__submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 0.5rem;\n  padding: 0.85rem 1.1rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.profile__submit:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.profile__submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .profile__layout {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
